import IvrSessionContent from 'src/models/Ivrs/IvrSessionContent';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import createDocumentResource from '../shared/createDocumentResource';

const ivrSessionContentResource = createDocumentResource<IvrSessionContent>({
  name: 'ivrSessionContent',
  endpoint: 'v1/orgs/:orgId/ivr-sessions/:id',
  observerCreator: emptyObserverCreator,
});

export default ivrSessionContentResource;
